/**
 * Created on 2025-08-11.
 * Copyright © 2025 Curriculum Ltd. All rights reserved.
 */

import { Component } from '@angular/core';

@Component({
  selector: 'curr-terms-of-use-content',
  templateUrl: './terms-of-use-content.component.html',
  styleUrls: ['./terms-of-use-content.component.scss']
})
export class TermsOfUseContentComponent {}
